import React from "react";
import { BRAND_BANNER, SLOGAN } from "@/lib/company";

export default function BrandShowcase() {
  return (
    <section
      className="py-20 lg:py-28 bg-gradient-to-b from-white to-[#f8fafc]"
      data-testid="brand-showcase-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-3xl mx-auto mb-12 reveal">
          <div className="text-xs font-semibold text-[#0B2D5C] tracking-[0.2em] uppercase mb-4">
            Nuestra esencia
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0f172a] leading-[1.1]">
            <span className="text-[#0B2D5C]">{SLOGAN}</span>
          </h2>
          <p className="mt-5 text-lg text-[#475569] leading-relaxed">
            Somos una empresa dedicada a acompañar a personas, familias y empresarios en cada etapa de su
            crecimiento en Estados Unidos.
          </p>
        </div>

        <div
          className="reveal relative rounded-sm overflow-hidden border border-[#e2e8f0] shadow-2xl bg-white max-w-3xl mx-auto"
          data-testid="brand-banner"
        >
          <img
            src={BRAND_BANNER}
            alt="Great Solutions US · Tu aliado para crecer en Estados Unidos"
            className="w-full h-auto max-h-[420px] object-contain block mx-auto"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
}
